import { FC } from 'react';
import { observer } from 'mobx-react';
import { Preferences } from '../preferences/preferences';
import { PageWrapper } from '../page-wrapper/page-wrapper';

export const PreferencesPage: FC = observer(() => {
    return (
        <PageWrapper>
            <Preferences />
        </PageWrapper>
    );
});
